import { supabase } from "~/integrations/supabase/client";
import type { Company, CompanyFormData } from "~/types/contabilidad";

export const companyService = {
  async getAll(): Promise<Company[]> {
    const { data, error } = await supabase
      .from("company")
      .select("*")
      .eq("is_deleted", false)
      .order("created_at", { ascending: false });

    if (error) throw error;
    return data as Company[];
  },

  async getById(id: string): Promise<Company> {
    const { data, error } = await supabase
      .from("company")
      .select("*")
      .eq("id", id)
      .eq("is_deleted", false)
      .single();

    if (error) throw error;
    return data as Company;
  },

  async search(query: string): Promise<Company[]> {
    const { data, error } = await supabase
      .from("company")
      .select("*")
      .eq("is_deleted", false)
      .ilike("name", `%${query}%`)
      .order("name", { ascending: true });

    if (error) throw error;
    return data as Company[];
  },

  async create(formData: CompanyFormData): Promise<Company> {
    const { data, error } = await supabase
      .from("company")
      .insert(formData)
      .select()
      .single();

    if (error) throw error;
    return data as Company;
  },

  async update(
    id: string,
    formData: Partial<CompanyFormData>
  ): Promise<Company> {
    const { data, error } = await supabase
      .from("company")
      .update(formData)
      .eq("id", id)
      .select()
      .single();

    if (error) throw error;
    return data as Company;
  },

  async delete(id: string): Promise<void> {
    // Soft delete
    const { error } = await supabase
      .from("company")
      .update({ is_deleted: true })
      .eq("id", id);

    if (error) throw error;
  },
};
